import { z } from 'zod';

import { isoDatetimeToDate } from '../codecs';

export type UploadStatusId = UploadStatus['id'];

export enum UploadState {
  IN_PROGRESS = 'in-progress',
  DONE = 'done',
  FROZEN = 'frozen',
}

export enum UploadSessionAssociationConfidence {
  POTENTIAL_MATCH = 'potential-match',
  CLEAR_MATCH = 'clear-match',
}

export type UploadStatus = z.output<typeof uploadStatusSchema>;
export type UploadStatusDTO = z.input<typeof uploadStatusSchema>;

export const uploadStatusSchema = z.object({
  associatedSession: z
    .object({
      /** The id of the session associated with this upload */
      id: z.string(),
      /** The level of association between the upload and the session */
      confidence: z.enum(UploadSessionAssociationConfidence),
    })
    .optional(),
  /** Optional end timestamp of the upload */
  end: isoDatetimeToDate.optional(),
  /** The id of the upload */
  id: z.string(),
  /** The id of the integration associated with this upload */
  integrationId: z.string(),
  /** Latest activity: completed object LastModified and/or in-progress multipart part times. */
  lastModified: isoDatetimeToDate.optional(),
  /** The progress of the upload */
  progress: z.number(),
  /** Optional end timestamp of the session included in this upload */
  sessionEnd: isoDatetimeToDate.optional(),
  /** Optional start timestamp of the session included in this upload */
  sessionStart: isoDatetimeToDate.optional(),
  /** Optional start timestamp of the upload */
  start: isoDatetimeToDate.optional(),
  /** The state of the upload */
  state: z.enum(UploadState),
});
